const labels = {
  All: { 'Ref: ServiceRequestLightHelpdeskTitle': 'Žádost o službu - HelpDesk' },
  List: {
    'Ref: You are requesting service on the site {siteName}.':
      'Požádáte o službu na webu {siteName}.',
  },
};
export default labels;
